import { Capacitor } from '@capacitor/core';
import { logError } from '@/lib/log';

/**
 * Trigger the OS-native in-app review sheet.
 *
 * - iOS  → SKStoreReviewController.requestReview()
 * - Android → Play In-App Review API
 *
 * The OS decides whether to actually render the sheet (both platforms throttle
 * heavily) and never reports back what — if anything — the user did. So this
 * resolves once we've *asked*; there is no success/rating signal to await.
 *
 * No-ops on web. The plugin is imported lazily so web bundles never load the
 * native shim and a missing/un-synced native plugin can't crash the app.
 */
export async function requestAppReview(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { InAppReview } = await import('@capacitor-community/in-app-review');
    await InAppReview.requestReview();
  } catch (error) {
    // Plugin not installed/synced yet, or the OS declined — fail silently.
    logError(error);
  }
}
